/*  Shared  */
import ObjectPicker from 'application/Shared/Components/Pickers/Components/ObjectPicker';
import Core from 'application/Shared/Helpers/Functions';
import { Requests } from 'application/Shared/Requests';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { Component } from 'react';

class MainCategoryTextPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            objectPayload: []
        };

        /* requests */
        this.requests = new Requests();
    }

    async componentDidMount() {
        const { onError } = this.props;
        try {
            const response = await axios.get('/category', {
                cancelToken: this.requests.token(),
                params: {
                    category: '*',
                    distinct: 'category',
                    fields: '[category]',
                    size: -1,
                    sort: 'id'
                }
            });
            if (Core.isset(response, 'data', 'data', 0)) {
                const payload = response.data.data.map((a) => ({
                    category: a.category,
                    id: a.category
                }));
                payload.push({
                    category: 'Uncategorized',
                    id: 'Uncategorized'
                });
                this.setState({ loaded: true, objectPayload: payload });
            } else if (onError) {
                onError();
            }
        } catch (err) {
            if (onError) {
                onError();
            }
        }
    }

    componentWillUnmount() {
        this.unload();
    }

    unload = () => {
        this.requests.cancel();
    };

    render() {
        const { loaded, objectPayload } = this.state;
        return (
            loaded && (
                <ObjectPicker
                    {...this.props}
                    objectPayload={objectPayload}
                    objectNameField="category"
                />
            )
        );
    }
}

export default MainCategoryTextPicker;
